import { render, staticRenderFns } from "./ProductLessons.vue?vue&type=template&id=f8178c06&scoped=true&"
import script from "./ProductLessons.vue?vue&type=script&lang=ts&"
export * from "./ProductLessons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8178c06",
  null
  
)

export default component.exports